import React from 'react';
import { Loader } from '@trackman/web-shared-components';
import { ITeam } from 'interfaces/team/ITeam';
import { observer } from 'mobx-react-lite';
import { useInjection } from 'services/ioc/ioc.react';
import { SessionStore } from 'stores/SessionStore';
import { ServiceTypes } from 'constants/ServiceTypes';
import LineupManager from 'models/setLineup/LineupManager';
import { TeamSelector } from '../TeamSelector/TeamSelector';
import { TeamSetup } from '../TeamSetup/TeamSetup';
import { TeamName, Title } from './TeamRosterStyles';

interface IProps {
  onTeamSelected: (team?: ITeam) => void;
  isLoading: boolean;
  teamManager: LineupManager | undefined;
  oppositeTeamManager: LineupManager | undefined;
  className: string;
  title: string;
  placeholder: string;
  size: 'sm' | 'lg';
  placeholderText?: string;
}

const TeamRoster: React.FC<IProps> = observer((props) => {
  const { onTeamSelected, isLoading, teamManager, oppositeTeamManager, title, placeholder, className, size, placeholderText, ...rest } =
    props;
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);

  return (
    <div className={className} {...rest}>
      <TeamName>
        <Title>{title}</Title>
        <TeamSelector
          placeholder={placeholder}
          onSelectionChange={(team: ITeam | undefined): void => onTeamSelected(team)}
          selectedTeam={teamManager?.team}
          isReadOnly={sessionStore.isScheduledGame}
          unavailableTeamId={sessionStore.currentSessionMode.privateSession ? undefined : oppositeTeamManager?.team.id}
        />
      </TeamName>
      <TeamSetup
        lineupManager={teamManager}
        isLoading={isLoading}
        unavailablePlayerIds={oppositeTeamManager?.getUnavailablePlayerIdsForOpposingTeam() || []}
        isPlaceholder={!teamManager}
        size={size}
        placeholderText={placeholderText}
        containerClass='.container'
      />
    </div>
  );
});

export default TeamRoster;
